import { render, staticRenderFns } from "./selecttbdw.vue?vue&type=template&id=5448722a&scoped=true&"
import script from "./selecttbdw.vue?vue&type=script&lang=js&"
export * from "./selecttbdw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5448722a",
  null
  
)

export default component.exports